import { css, cx } from 'linaria';
export const tooltipStyles = "t1221eea";
export const placementBottom = "pzhe358";
export const placementTop = "pmdugmx";
export const delayStyle = "d1ihjjkq";
export const bottomTooltip = cx(tooltipStyles, placementBottom);
export const bottomTooltipDelayed = cx(tooltipStyles, placementBottom, delayStyle);
export const topTooltip = cx(tooltipStyles, placementTop);
export const topTooltipDelayed = cx(tooltipStyles, placementTop, delayStyle);

require("../../../.linaria-cache/src/components/tooltip/tooltip.linaria.module.css");